<div class="avatar_cointainer">
    <ng-container *ngFor="let people of approvalMembers| slice:0:2;let j = index">
        <div class="cir" matTooltip="{{people}}" [ngClass]="avatarStyle">
            {{ people.split(' ')[0] | slice:0:1 }}{{ people.split(' ')[1] | slice:0:1 }}
        </div>
    </ng-container>
</div>